/**
 * Maximum string lengths enforced by the API database schema.
 *
 * Every value mirrors a `[MaxLength(n)]` attribute on the matching entity in BFI-web-app-BE
 * (FirstFinancial/Models). Postgres rejects anything longer and the save fails with a 500, so any input
 * bound to one of these fields should pass the matching value as `maxLength`.
 *
 * Keep this file in sync when a `[MaxLength]` attribute changes on the backend.
 */

/** Mirrors FirstFinancial/Models/Common/Address.cs */
export const AddressFieldLength = {
    street1: 50,
    street2: 50,
    city: 50,
    state: 15,
    zipCode: 10,
    county: 50,
} as const;

/** Mirrors FirstFinancial/Models/Applications/Application.cs */
export const ApplicationFieldLength = {
    withdrawalReason: 255,
    companyTaxReturnAdditionalInfo: 255,
    personalTaxReturnAdditionalInfo: 255,
    unableToVerifyIdentityDeclineReason: 255,
} as const;

/**
 * Mirrors FirstFinancial/Models/Applications/ApplicationProperty.cs and the per-loan-type subclasses
 * (ApplicationPropertyConstruction, ApplicationPropertyFixFlip, ApplicationPropertyLand, ApplicationPropertyBridge),
 * which all declare the same on-site contact limits.
 */
export const ApplicationPropertyFieldLength = {
    legalDescription: 500,
    contactName: 100,
    contactFirstName: 50,
    contactMiddleName: 20,
    contactLastName: 50,
    contactEmail: 320,
    contactSecondaryEmail: 320,
    contactPhone: 15,
} as const;

/** Mirrors FirstFinancial/Models/Applications/ApplicationPropertyNonRental.cs */
export const ApplicationNonRentalFieldLength = {
    landSizeQuantity: 100,
    landSizeUnit: 100,
    generalContractorName: 200,
} as const;

/** Mirrors FirstFinancial/Models/Borrowers/BorrowerEntity.cs (its address columns match Address.cs). */
export const BorrowerEntityFieldLength = {
    name: 100,
    tin: 12,
    stateIncorporated: 15,
    workingRelationship: 200,
    ...AddressFieldLength,
} as const;
